import UndoIcon from "@mui/icons-material/Undo";
import { FileListItem } from "@shared";

import { PendingDocumentMove } from "@/common/components/layout/components/dropzone/dnd/DropZoneDnd.types";
import { useTranslation } from "@/translations";

interface Props {
  move: PendingDocumentMove;
  onCancel: () => void;
}

/**
 * Row for a document whose move is pending until the owning form is saved. Intentionally not
 * draggable or selectable — while pending, this is the document's only visible row, which rules
 * out double-moves.
 */
export function PendingMoveRow({ move, onCancel }: Props) {
  const { t } = useTranslation();

  return (
    <FileListItem
      fileName={move.document.fileName}
      contentType={move.document.contentType}
      sizeBytes={move.document.fileSizeBytes}
      secondaryText={t("dropzone.dnd.pendingMove")}
      menuItems={[
        {
          key: "cancel-move",
          label: t("dropzone.dnd.cancelMove"),
          icon: <UndoIcon />,
          onClick: onCancel,
        },
      ]}
    />
  );
}
